import {
  Day,
  HoursOff,
  useDeleteHoursOff,
  useUpdateHoursOff
} from "@mc-intranet/shared";
import { DeleteOutlineOutlined } from "@mui/icons-material";
import LoadingButton from "@mui/lab/LoadingButton";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Stack
} from "@mui/material";
import { useAtomValue } from "jotai";
import { Moment } from "moment";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";

import { daysByUserQueryVariablesSelector } from "../../../atoms";
import { useGraphQLClient } from "../../../cache";
import Times from "./Times";

interface Props {
  userId?: string | null;
  day: Day;
  hoursOff: HoursOff;
  setCurrentDay: React.Dispatch<
    React.SetStateAction<Day | undefined | null>
  >;
}

const UpdateHoursOff: React.FC<Props> = (props) => {
  const { day, hoursOff, setCurrentDay } = props;
  const { client } = useGraphQLClient();
  const variables = useAtomValue(daysByUserQueryVariablesSelector);

  const [deleting, setDeleting] = useState(false);
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const {
    deleteHoursOffMutation,
    options: { isLoading: deletingHoursOff }
  } = useDeleteHoursOff({
    day,
    setCurrentDay,
    client,
    variables
  });

  const onRemoveHoursOff = () => {
    setOpen(false);
    setDeleting(true);
    deleteHoursOffMutation(
      {
        id: hoursOff.documentId as string
      },
      {
        onError: (error: any) => {
          console.log("error ", error);
          toast.error(error?.response?.error.message, {
            position: toast.POSITION.TOP_CENTER
          });
        }
      }
    );
  };

  useEffect(() => {
    if (!deletingHoursOff) {
      setDeleting(false);
    }
  }, [deletingHoursOff]);

  const { updateHoursOffMutation } = useUpdateHoursOff({
    day,
    setCurrentDay,
    client,
    variables
  });

  const onTimeChange = (time: Moment | null, name: string) => {
    updateHoursOffMutation(
      {
        id: hoursOff.documentId as string,
        [name]: time?.format("HH:mm:ss.SSS")
      },
      {
        onSuccess: () => {
          toast.success("Permessi aggiornati con successo", {
            position: toast.POSITION.TOP_CENTER
          });
        },
        onError: (error: any) => {
          console.log("error ", error);
          toast.error(error?.response?.error.message, {
            position: toast.POSITION.TOP_CENTER
          });
        }
      }
    );
  };

  return (
    <>
      <Stack direction="row" spacing={2} mt={2} width="100%">
        <Times day={day} hoursOff={hoursOff} onTimeChange={onTimeChange} />
        <LoadingButton
          key="remove"
          size="large"
          startIcon={<DeleteOutlineOutlined />}
          loading={deleting}
          sx={{ minWidth: "30px", p: 0, fontSize: "1.2rem" }}
          onClick={handleClickOpen}
        />
      </Stack>
      <Dialog open={open}>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Sicuro di voler cancellare la riga?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button color="secondary" onClick={handleClose}>
            No
          </Button>
          <Button variant="contained" onClick={onRemoveHoursOff} autoFocus>
            Si
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default UpdateHoursOff;
